module.exports = __webpack_public_path__ + "img/close.36e862e8.svg";